const hpInfoStore = {
    state: {
        host: '',
        hpCd: '',
        instNo: '',
        lang: '',
        hosNm: ''
    },
    mutations: {
        getHost: function (state, host) {
            state.host = host;
        },
        getHpCd: function (state, hpCd) {
            state.hpCd = hpCd;
        },
        getInstNo: function (state, instNo) {
            state.instNo = instNo;
        },
        getLang: function (state, lang) {
            state.lang = lang;
        },
        getHosNm: function (state, hosNm) {
            state.hosNm = hosNm;
        }
    }
}

export default hpInfoStore